module.exports = __webpack_public_path__ + "static/media/14.8bb4e37f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/14.png
// module id = 380
// module chunks = 0